<div class="sidebar-main">
  <a routerLink="/" class="logo-holder" [class.loading]="isLoading$ | async">
    <svg-icon class="logo" src="/assets/logo.svg"></svg-icon>
    <img src="assets/app-loading.gif" alt="" title="" class="loading-logo" />
  </a>
  <button
    type="button"
    class="sidebar-toggle"
    (click)="toggleExpanded()"
    [matTooltip]="isExpanded ? 'Collapse sidebar' : 'Expand sidebar'"
    matTooltipPosition="right"
    [attr.aria-expanded]="isExpanded"
    aria-label="Toggle sidebar"
  >
    <i class="far" [class.fa-angle-left]="isExpanded" [class.fa-angle-right]="!isExpanded"></i>
  </button>
  <app-overflow-scroll class="top_items">
    <div class="sidebar_items_wrapper" data-overflow-scroll-content-container>
      <a
        class="sidebar_item"
        *ngxPermissionsOnly="['canSeeCalendar']"
        matTooltip="Calendars"
        i18n-matTooltip
        matTooltipPosition="right"
        [matTooltipDisabled]="isExpanded"
        routerLinkActive="active"
        routerLink="/calendar/multi"
      >
        <i class="cs-icon cs-icon-calendars text-xl"></i>
        <span class="sidebar_item_label" *ngIf="isExpanded" i18n>Calendars</span>
      </a>
      <a
        class="sidebar_item"
        *ngxPermissionsOnly="['canSeeGuests']"
        matTooltip="Guests"
        i18n-matTooltip
        matTooltipPosition="right"
        [matTooltipDisabled]="isExpanded"
        routerLinkActive="active"
        routerLink="/guests"
      >
        <i class="cs-icon cs-icon-guests text-xl"></i>
        <span class="sidebar_item_label" *ngIf="isExpanded" i18n>Guests</span>
      </a>
      <a
        class="sidebar_item"
        *ngxPermissionsOnly="['canSeeInquiries']"
        matTooltip="Inquiries"
        i18n-matTooltip
        matTooltipPosition="right"
        [matTooltipDisabled]="isExpanded"
        routerLinkActive="active"
        routerLink="/inquiries/inbox"
      >
        <i class="cs-icon cs-icon-inquiries"></i>
        <span class="sidebar_item_label" *ngIf="isExpanded" i18n>Inquiries</span>
      </a>
      <ng-container *ngxPermissionsOnly="['canSeeInvoices']">
        <a
          class="sidebar_item"
          [class.active]="isExpanded && activeGroup === 'finances'"
          matTooltip="Finances"
          i18n-matTooltip
          matTooltipPosition="right"
          [matTooltipDisabled]="isExpanded"
          (click)="onFinancesClick()"
          cdkOverlayOrigin
          #paymentTrigger="cdkOverlayOrigin"
        >
          <i class="cs-icon cs-icon-dollar-circle"></i>
          <span class="sidebar_item_label" *ngIf="isExpanded" i18n>Finances</span>
        </a>
        <ng-template
          cdkConnectedOverlay
          (overlayOutsideClick)="isPaymentsMenuOpen = false"
          [cdkConnectedOverlayOffsetX]="20"
          [cdkConnectedOverlayOffsetY]="-100"
          [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top' }]"
          [cdkConnectedOverlayOrigin]="paymentTrigger"
          [cdkConnectedOverlayOpen]="isPaymentsMenuOpen && !isExpanded"
        >
          <div>
            <ul class="dropdown-menu show position-relative" style="top: 0" (click)="isPaymentsMenuOpen = false">
              <li class="py-2 px-3 text-uppercase text-semi-bold text-light text-sm" i18n>Finances</li>
              <li class="menu-item-success">
                <a routerLink="/invoices/list">
                  <i class="cs-icon cs-icon-file-dollar text-xl"></i>
                  <ng-container i18n>Invoices</ng-container>
                </a>
              </li>
              <li class="menu-item-success">
                <a routerLink="/charges">
                  <i class="cs-icon cs-icon-dollar-square"></i>
                  <ng-container i18n>Charges</ng-container>
                </a>
              </li>
              <li class="menu-item-success">
                <a routerLink="/extras">
                  <i class="cs-icon cs-icon-dollar-circle-plus-circle text-xxl"></i>
                  <ng-container i18n>Extras</ng-container>
                </a>
              </li>
              <li class="dropdown-divider"></li>
              <li class="menu-item-danger" *ngxPermissionsOnly="['canSeeExpenses']">
                <a routerLink="/expenses">
                  <i class="cs-icon cs-icon-bill-dollar text-xl"></i>
                  <ng-container i18n>Expenses</ng-container>
                </a>
              </li>
              <li class="dropdown-divider"></li>
              <li class="menu-item-indigo">
                <a routerLink="/formulas">
                  <i class="cs-icon cs-icon-calendar-dollar-circle text-xl"></i>
                  <ng-container i18n>Booking Formulas</ng-container>
                </a>
              </li>
              <li class="menu-item-indigo">
                <a routerLink="/discounts">
                  <i class="cs-icon cs-icon-discount text-xl"></i>
                  <ng-container i18n>Discounts</ng-container>
                </a>
              </li>
              <li class="menu-item-indigo" *ngIf="showSecurityDeposits">
                <a routerLink="/security-deposits">
                  <i class="cs-icon cs-icon-dollar-circle-plus-circle text-xl"></i>
                  <ng-container i18n>Security Deposits</ng-container>
                </a>
              </li>
            </ul>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngxPermissionsOnly="['canSeeTasks', 'canSeeIncidents', 'canSeeInventories', 'canSeeVendors']">
        <a
          class="sidebar_item"
          [class.active]="isExpanded && activeGroup === 'operations'"
          i18n-matTooltip
          matTooltip="Operations"
          matTooltipPosition="right"
          [matTooltipDisabled]="isExpanded"
          (click)="onOperationsClick()"
          cdkOverlayOrigin
          #tasksTrigger="cdkOverlayOrigin"
        >
          <i class="cs-icon cs-icon-tasks"></i>
          <span class="sidebar_item_label" *ngIf="isExpanded" i18n>Operations</span>
        </a>
        <ng-template
          cdkConnectedOverlay
          (overlayOutsideClick)="isTasksMenuOpen = false"
          [cdkConnectedOverlayOffsetX]="20"
          [cdkConnectedOverlayOffsetY]="-100"
          [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top' }]"
          [cdkConnectedOverlayOrigin]="tasksTrigger"
          [cdkConnectedOverlayOpen]="isTasksMenuOpen && !isExpanded"
        >
          <div>
            <ul class="dropdown-menu show position-relative" style="top: 0" (click)="isTasksMenuOpen = false">
              <li class="py-2 px-3 text-uppercase text-semi-bold text-light text-sm">
                <ng-container i18n>Operations</ng-container>
              </li>
              <li class="menu-item-success" *ngxPermissionsOnly="'canSeeTasks'">
                <a routerLink="/tasks/list">
                  <i class="cs-icon cs-icon-tasks text-xxl"></i>
                  <ng-container i18n>Tasks</ng-container>
                </a>
              </li>
              <li class="menu-item-danger" *ngxPermissionsOnly="'canSeeIncidents'">
                <a routerLink="/incidents">
                  <i class="cs-icon cs-icon-building-incident text-xl"></i>
                  <ng-container i18n>Incidents</ng-container>
                </a>
              </li>
              <li class="menu-item-indigo" *ngxPermissionsOnly="'canSeeInventories'">
                <a routerLink="/inventories">
                  <i class="cs-icon cs-icon-inventory text-lg"></i>
                  <ng-container i18n>Inventories</ng-container>
                </a>
              </li>
              <li class="menu-item-info" *ngxPermissionsOnly="'canSeeVendors'">
                <a routerLink="/vendors">
                  <i class="cs-icon cs-icon-store text-lg"></i>
                  <ng-container i18n>Vendors</ng-container>
                </a>
              </li>
            </ul>
          </div>
        </ng-template>
      </ng-container>
      <a
        class="sidebar_item"
        *ngxPermissionsOnly="['canSeeReviews']"
        routerLinkActive="active"
        routerLink="/reviews"
        matTooltip="Reviews"
        i18n-matTooltip
        matTooltipPosition="right"
        [matTooltipDisabled]="isExpanded"
      >
        <i class="cs-icon cs-icon-reviews text-xl"></i>
        <span class="sidebar_item_label" *ngIf="isExpanded" i18n>Reviews</span>
      </a>
      <a
        *ngxPermissionsOnly="['canSeeAirbnbQuality']"
        class="sidebar_item"
        routerLinkActive="active"
        routerLink="/airbnb-quality"
        matTooltip="Airbnb Quality"
        i18n-matTooltip
        matTooltipPosition="right"
        [matTooltipDisabled]="isExpanded"
      >
        <i class="cs-icon cs-icon-airbnb-quality text-xxl"></i>
        <span class="sidebar_item_label" *ngIf="isExpanded" i18n>Airbnb Quality</span>
      </a>
      <a
        *ngxPermissionsOnly="['canSeeSmartDevices']"
        class="sidebar_item"
        routerLinkActive="active"
        routerLink="/devices"
        matTooltip="Smart Devices"
        i18n-matTooltip
        matTooltipPosition="right"
        [matTooltipDisabled]="isExpanded"
      >
        <i class="cs-icon cs-icon-smart-devices text-xl"></i>
        <span class="sidebar_item_label" *ngIf="isExpanded" i18n>Smart Devices</span>
      </a>
      <ng-container *ngxPermissionsOnly="['canSeeDocuments']">
        <a
          class="sidebar_item"
          i18n-matTooltip
          matTooltip="Documents"
          matTooltipPosition="right"
          [matTooltipDisabled]="isExpanded"
          routerLinkActive="active"
          routerLink="/documents"
        >
          <i class="far fa-file-signature text-xl"></i>
          <span class="sidebar_item_label" *ngIf="isExpanded" i18n>Documents</span>
        </a>
      </ng-container>
      <ng-container *ngxPermissionsOnly="['canSeeReports']">
        <a
          class="sidebar_item"
          *ngIf="'margins' | UserAccess"
          [href]="reportsUrl()"
          target="_blank"
          matTooltip="Reports"
          i18n-matTooltip
          matTooltipPosition="right"
          [matTooltipDisabled]="isExpanded"
        >
          <i class="cs-icon cs-icon-reports text-xl"></i>
          <span class="sidebar_item_label" *ngIf="isExpanded" i18n>Reports</span>
        </a>
      </ng-container>
    </div>
  </app-overflow-scroll>
  <div class="bottom_items gap-3">
    <div class="bottom_item">
      <app-help-widget></app-help-widget>
    </div>
    <div class="bottom_item">
      <app-avatar
        [text]="username"
        (click)="isUserActionsMenuOpen = !isUserActionsMenuOpen"
        cdkOverlayOrigin
        #userTrigger="cdkOverlayOrigin"
        class="clickable"
      ></app-avatar>
    </div>
  </div>
</div>

<div class="sidebar-subnav" *ngIf="isExpanded && activeGroup">
  <ng-container *ngIf="activeGroup === 'finances'">
    <ng-container *ngxPermissionsOnly="['canSeeInvoices']">
      <div class="subnav-title" i18n>Finances</div>
      <a routerLink="/invoices/list" routerLinkActive="active" i18n>Invoices</a>
      <a routerLink="/charges" routerLinkActive="active" i18n>Charges</a>
      <a routerLink="/extras" routerLinkActive="active" i18n>Extras</a>
      <a routerLink="/expenses" routerLinkActive="active" *ngxPermissionsOnly="['canSeeExpenses']" i18n>Expenses</a>
      <a routerLink="/formulas" routerLinkActive="active" i18n>Booking Formulas</a>
      <a routerLink="/discounts" routerLinkActive="active" i18n>Discounts</a>
      <a routerLink="/security-deposits" routerLinkActive="active" *ngIf="showSecurityDeposits" i18n>
        Security Deposits
      </a>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="activeGroup === 'operations'">
    <ng-container *ngxPermissionsOnly="['canSeeTasks', 'canSeeIncidents', 'canSeeInventories', 'canSeeVendors']">
      <div class="subnav-title" i18n>Operations</div>
      <a routerLink="/tasks/list" routerLinkActive="active" *ngxPermissionsOnly="'canSeeTasks'" i18n>Tasks</a>
      <a routerLink="/incidents" routerLinkActive="active" *ngxPermissionsOnly="'canSeeIncidents'" i18n>Incidents</a>
      <a routerLink="/inventories" routerLinkActive="active" *ngxPermissionsOnly="'canSeeInventories'" i18n>
        Inventories
      </a>
      <a routerLink="/vendors" routerLinkActive="active" *ngxPermissionsOnly="'canSeeVendors'" i18n>Vendors</a>
    </ng-container>
  </ng-container>
</div>

<ng-template
  cdkConnectedOverlay
  (overlayOutsideClick)="isUserActionsMenuOpen = false"
  [cdkConnectedOverlayOffsetX]="20"
  [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'bottom' }]"
  [cdkConnectedOverlayOrigin]="userTrigger"
  [cdkConnectedOverlayOpen]="isUserActionsMenuOpen"
>
  <div
    class="bg-white shadow2 border rounded overflow-hidden"
    style="width: 416px"
    (click)="isUserActionsMenuOpen = false"
  >
    <div class="user-actions-menu-header">
      <app-avatar [text]="username" [circle]="true" [size]="70"></app-avatar>
      <div class="d-flex flex-column gap-1 w-100 text-truncate">
        <div class="text-dark font-weight-bolder text-lg d-flex align-items-center">
          <div class="text-truncate flex-1">
            {{ username }}
          </div>
          <a routerLink="/account" *ngxPermissionsOnly="['canSeeAccount']" class="text-dark">
            <i class="cs-icon cs-icon-pencil"></i>
          </a>
        </div>
        <div>{{ user.primaryEmail }}</div>
        <div>
          {{ user.account }}
          <app-copy-icon [content]="user.account"></app-copy-icon>
        </div>
        <div>
          <span class="badge badge-secondary-info">{{ role }}</span>
        </div>
      </div>
    </div>
    <ul class="list-group list-group-flush user-actions-menu actions-menu">
      <li
        *ngxPermissionsOnly="['canSeeAccount']"
        class="list-group-item"
        matTooltip="Manage your account preferences, company details, and domain name."
        i18n-matTooltip
        matTooltipPosition="left"
        (mouseenter)="isLanguageSwitcherOpen = false"
      >
        <a
          routerLink="/account"
          (mouseenter)="icon1.classList.add('focus')"
          (mouseleave)="icon1.classList.remove('focus')"
        >
          <span class="btn btn-sm btn-secondary-primary-reverse" #icon1>
            <i class="cs-icon cs-icon-user2"></i>
          </span>
          <ng-container i18n>Account Info</ng-container>
        </a>
      </li>
      <li
        class="list-group-item"
        matTooltip="Manage your user settings"
        i18n-matTooltip
        matTooltipPosition="left"
        (mouseenter)="isLanguageSwitcherOpen = false"
      >
        <a
          routerLink="/settings/user-settings/current"
          (mouseenter)="icon7.classList.add('focus')"
          (mouseleave)="icon7.classList.remove('focus')"
        >
          <span class="btn btn-sm btn-secondary-primary-reverse" #icon7>
            <i class="cs-icon cs-icon-cog"></i>
          </span>
          <ng-container i18n>User Settings</ng-container>
        </a>
      </li>
      <li class="list-group-item">
        <ng-container>
          <a
            (mouseenter)="icon6.classList.add('focus'); isLanguageSwitcherOpen = true"
            (mouseleave)="icon6.classList.remove('focus')"
            cdkOverlayOrigin
            #languageTrigger="cdkOverlayOrigin"
          >
            <span class="btn btn-sm btn-secondary-success-reverse text-lg" #icon6>
              <i class="cs-icon cs-icon-language"></i>
            </span>
            <ng-container i18n>{{ currentLanguage.name }}</ng-container>
          </a>
          <ng-template
            cdkConnectedOverlay
            (overlayOutsideClick)="isLanguageSwitcherOpen = false"
            [cdkConnectedOverlayOffsetX]="25"
            [cdkConnectedOverlayOffsetY]="250"
            [cdkConnectedOverlayPositions]="[
              { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'bottom' }
            ]"
            [cdkConnectedOverlayOrigin]="languageTrigger"
            [cdkConnectedOverlayOpen]="isLanguageSwitcherOpen"
          >
            <div>
              <ul class="dropdown-menu show position-relative" style="top: 0">
                <li class="menu-item-success" *ngFor="let lang of languages">
                  <a (click)="switchLanguage(lang.value)" [class.active]="currentLanguage?.value === lang.value">
                    {{ lang.name }}
                    <i class="far fa-check" *ngIf="currentLanguage?.value === lang.value"></i>
                  </a>
                </li>
              </ul>
            </div>
          </ng-template>
        </ng-container>
      </li>
      <li
        *ngxPermissionsOnly="['canChangePassword']"
        class="list-group-item"
        matTooltip="Change your password."
        i18n-matTooltip
        matTooltipPosition="left"
        (mouseenter)="isLanguageSwitcherOpen = false"
      >
        <a
          (click)="onChangePassword()"
          (mouseenter)="icon2.classList.add('focus')"
          (mouseleave)="icon2.classList.remove('focus')"
        >
          <span class="btn btn-sm btn-secondary-indigo-reverse text-lg" #icon2>
            <i class="cs-icon cs-icon-key2"></i>
          </span>
          <ng-container i18n>Change Password</ng-container>
        </a>
      </li>
      <li class="list-group-item" matTooltip="Configure MFA" i18n-matTooltip matTooltipPosition="left">
        <a (click)="onMFA()" (mouseenter)="icon6.classList.add('focus')" (mouseleave)="icon6.classList.remove('focus')">
          <span class="btn btn-sm btn-secondary-warning-reverse text-lg" #icon6>
            <i class="cs-icon cs-icon-cog"></i>
          </span>
          <ng-container i18n>Configure MFA</ng-container>
        </a>
      </li>
      <li
        *ngxPermissionsOnly="['canSeeBilling']"
        class="list-group-item"
        matTooltip="Manage your subscription, payment details, and view your billing history."
        i18n-matTooltip
        matTooltipPosition="left"
      >
        <a
          routerLink="/billing/info"
          (mouseenter)="icon3.classList.add('focus')"
          (mouseleave)="icon3.classList.remove('focus')"
        >
          <span class="btn btn-sm btn-secondary-success-reverse text-lg" #icon3>
            <i class="cs-icon cs-icon-file-dollar"></i>
          </span>
          <ng-container i18n>Billing Info</ng-container>
        </a>
      </li>
      <li
        *ngxPermissionsOnly="['canSeeChangelog']"
        class="list-group-item"
        matTooltip="Stay updated about changes and new features in AdvanceCM."
        i18n-matTooltip
        matTooltipPosition="left"
      >
        <a
          (click)="goToChangelog()"
          (mouseenter)="icon4.classList.add('focus')"
          (mouseleave)="icon4.classList.remove('focus')"
        >
          <span class="btn btn-sm btn-secondary-info-reverse text-lg" #icon4>
            <i class="cs-icon cs-icon-file-arrow-border"></i>
          </span>
          <ng-container i18n>AdvanceCM Changelog</ng-container>
        </a>
      </li>
      <li class="list-group-item">
        <a
          (click)="logout()"
          role="link"
          (mouseenter)="icon5.classList.add('focus')"
          (mouseleave)="icon5.classList.remove('focus')"
        >
          <span class="btn btn-sm btn-secondary-danger-reverse text-lg" #icon5>
            <i class="cs-icon cs-icon-logout2"></i>
          </span>
          <ng-container i18n>Logout</ng-container>
        </a>
      </li>
    </ul>
  </div>
</ng-template>
